import { render, staticRenderFns } from "./ViewUser.vue?vue&type=template&id=5aa4e710&scoped=true&"
import script from "./ViewUser.vue?vue&type=script&lang=js&"
export * from "./ViewUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa4e710",
  null
  
)

export default component.exports